module.exports = __webpack_public_path__ + "img/electronic_reserved_selected.d8ad50cc.svg";